import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { colors } from '@seeqdev/qomponents/colors.stylex';

interface FormErrorProps {
  errorText: string;
  errorParameters?: Record<string, string | number>;
  xstyle?: stylex.StyleXStyles;
  extraClassNames?: string;
  dataTestId?: string;
}

export const FormError = (props: FormErrorProps) => {
  const { errorText, errorParameters, extraClassNames, dataTestId } = props;
  const { t } = useTranslation();

  return (
    <div
      {...stylex.props(formErrorStyles.error, props.xstyle)}
      className={clsx(stylex.props(formErrorStyles.error, props.xstyle).className, extraClassNames)}
      data-testid={dataTestId}>
      {errorParameters ? t(errorText, errorParameters) : t(errorText)}
    </div>
  );
};

export const formErrorStyles = stylex.create({
  error: { color: colors.borderInvalid, marginTop: '.3125rem' },
});
